import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Review } from '../models/Review';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  private http = inject(HttpClient);
  private apiUrl = environment.backend;

  getReviews(restStopId: number): Observable<Review[]> {
    return this.http.get<Review[]>(`${this.apiUrl}/rest-stops/${restStopId}/reviews`);
  }

  postReview(restStopId: number, rating: number, comment: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/rest-stops/${restStopId}/reviews`, {
      rating,
      comment,
    });
  }

  getReviewsByUser(username: string): Observable<Review[]> {
    return this.http.get<Review[]>(`${this.apiUrl}/users/${username}/reviews`);
  }

  updateReview(restStopId: number, reviewId: number, rating: number, comment: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/rest-stops/${restStopId}/reviews/${reviewId}`, { rating, comment });
  }
}
